// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/components/edit-sites/edit-sites.less
// module id = 3489
// module chunks = 0